<template>

  <a :href="href" :class="classes" v-html="settings.label" @click="clicked($event)" :target="target" v-if="show" />

</template>

<script>
export default {
  name: 'TableButton',
  props: ['settings'],
  data() {
    return {
      
    }
  },
 created() {
  },
  computed: {

    href() {
      return this.settings.href ? this.settings.href : '#';
    },
    target() {
      return this.settings.target ? this.settings.target : '_self';
    },
    show() {
      return ( typeof this.settings.hide === 'undefined' || this.settings.hide === false );
    },
    classes() {
      let c = typeof this.settings.classes !== 'undefined' ? this.settings.classes : {};
      if ( typeof this.settings.click !== 'undefined' ) c['no-click'] = !this.settings.click;
      c['table-button'] = true;
      return c;
    }

  },
  methods: {
  
    clicked(e) {

      if ( this.href === '#' ) e.preventDefault();
      
      if ( this.settings.click && this.href === '#' ) {

        this.$emit('clicked',null);

      }

    }

  }
}
</script>
<style lang="less" scoped>
@import './../../assets/css/less/_helper.less';
@import './../../assets/css/less/_settings.less';
.table-button {
  display: inline-block;
  text-decoration: none;
  background-color: @darkContrast;
  color: #fff;
  .rounded(5px);
  border: 2px solid @darkContrast;
  padding:2px 4px;
  font-size: 12px;
  margin-top: 0;
  margin-right: 20px;
  .trans;
  &:not(.no-click) {
    &:hover {
      color: @darkContrast;
      background-color: white;
    }
  }
  &.no-click {
    cursor: default;
  }
  &.red {
    background-color: @red;
    border-color: @red;
    &:not(.no-click) {
      &:hover {
        color: @red;
        background-color: white;
      }
    }
  }
  &.green {
    background-color: @green;
    border-color: @green;
    &:not(.no-click) {
      &:hover {
        color: @green;
        background-color: white;
      }
    }
  }
  &.orange {
    background-color: @orange;
    border-color: @orange;
    &:not(.no-click) {
      &:hover {
        color: @orange;
        background-color: white;
      }
    }
  }
  &.default {
    background-color: @formDefaultColour;
    border-color: @formDefaultColour;
    &:not(.no-click) {
      &:hover {
        color: @formDefaultColour;
        background-color: white;
      }
    }
  }
}
@media screen and (min-width: 960px) {

  .table-button {

    margin-top:10px;
    margin-bottom:10px;

  }

}
</style>